<template>
  <div class="ccvidyo-component" @click="showConstBtns()" style="height: 100%">
    <div v-if="!callOnHold && showVideoButtons" style="position: absolute">
      <v-tooltip
        :text="videoView.menu ? videoView.menu : 'Menu'"
        location="bottom"
        v-if="videoView.isShowMenu"
      >
        <template v-slot:activator="{ props }">
          <v-btn
            id="menu-btn"
            v-bind="props"
            rounded
            class="mx-2 control-button"
            @click="showTooltip('tooltip-menu')"
            @click.stop="drawer = !drawer"
            icon
          >
            <img
              v-if="videoView.reorderIconLink"
              class="control-button-image"
              :src="videoView.reorderIconLink"
            />
            <img
              v-else-if="!videoView.reorderIconLink"
              class="control-button-image"
              :src="require('@/assets/Reorder.svg')"
            />
          </v-btn>
        </template>
      </v-tooltip>
      <div id="constBtnsWrapper" @mouseover="showConstBtns()">
        <div id="video-const-buttons" v-show="!drawer && isShowConstBtns">
          <v-tooltip
            :text="
              videoView.switchToChatLabel ? videoView.switchToChatLabel : 'Chat'
            "
            location="bottom"
          >
            <template v-slot:activator="{ props }">
              <v-btn
                id="change-to-chat-btn"
                v-bind="props"
                rounded
                class="mx-2 control-button"
                @click="
                  changeToChat();
                  showTooltip('tooltip-change-to-chat-1');
                "
                style="float: right"
                icon
              >
                <v-badge color="pink" dot v-if="$store.state.newMessageCome">
                  <img
                    v-if="videoView.chatIconLink"
                    class="control-button-image"
                    :src="videoView.chatIconLink"
                  />
                  <img
                    v-else-if="!videoView.chatIconLink"
                    class="control-button-image"
                    :src="require('@/assets/Chat_Icon.svg')"
                  />
                </v-badge>
                <img
                  v-else-if="
                    !$store.state.newMessageCome && videoView.chatIconLink
                  "
                  class="control-button-image"
                  :src="videoView.chatIconLink"
                />
                <img
                  v-else-if="
                    !$store.state.newMessageCome && !videoView.chatIconLink
                  "
                  class="control-button-image"
                  :src="require('@/assets/Chat_Icon.svg')"
                />
              </v-btn>
            </template>
          </v-tooltip>

          <v-tooltip
            :text="!isMicMuted ? videoView.micLabel : videoView.micOffLabel"
            location="bottom"
          >
            <template v-slot:activator="{ props }">
              <v-btn
                id="mute-unmute-mic-btn"
                v-bind="props"
                rounded
                :class="{
                  'mic-muted': isMicMuted,
                  'mic-unmuted': !isMicMuted,
                }"
                class="mx-2 control-button"
                @click="
                  switchMuteMic();
                  showTooltip('tooltip-mute-mic-btn-1');
                "
                style="float: right"
                icon
                color="red"
              >
                <img
                  class="control-button-image"
                  :src="
                    !isMicMuted
                      ? videoView.micIconLink
                      : videoView.micOffIconLink
                  "
                />
              </v-btn>
            </template>
          </v-tooltip>

          <v-tooltip
            location="bottom"
            v-if="videoView.isShowShareScreenBtn"
            :text="
              !onShare
                ? videoView.shareScreenLabel
                : videoView.shareScreenOffLabel
            "
          >
            <template v-slot:activator="{ props }">
              <v-btn
                id="share-screen-btn"
                rounded
                v-bind="props"
                class="mx-2 control-button"
                @click="
                  handleShare();
                  showTooltip('tooltip-share-btn');
                "
                style="float: right"
                :class="{
                  'share-on': onShare,
                }"
                icon
                color="red"
              >
                <img
                  class="control-button-image"
                  :src="videoView.shareScreenIconLink"
                />
              </v-btn>
            </template>
          </v-tooltip>

          <v-tooltip
            :text="
              !isCamMuted ? videoView.cameraLabel : videoView.cameraOffLabel
            "
            location="bottom"
          >
            <template v-slot:activator="{ props }">
              <v-btn
                id="mute-unmute-cam-btn"
                v-bind="props"
                rounded
                class="mx-2 control-button"
                :class="{
                  'cam-muted': isCamMuted,
                  'cam-unmuted': !isCamMuted,
                }"
                @click="
                  switchMuteCamera();
                  showTooltip('tooltip-mute-unmute-cam-2');
                "
                style="float: right"
                icon
                color="red"
              >
                <img
                  class="control-button-image"
                  :src="
                    !isCamMuted
                      ? videoView.cameraIconLink
                      : videoView.cameraOffIconLink
                  "
                />
              </v-btn>
            </template>
          </v-tooltip>

          <v-tooltip
            :text="
              videoView.switchCameraLabel
                ? videoView.switchCameraLabel
                : 'Switch Camera'
            "
            location="bottom"
          >
            <!-- <template v-slot:activator="{ on: onTooltip, attrs }"> -->
            <!-- <v-menu offset-y z-index="1000000000000000000000000"> -->
            <template v-slot:activator="{ props }">
              <v-btn
                id="cycle-camera-btn"
                v-bind="props"
                rounded
                class="mx-2 control-button"
                @click="
                  cycleCamera();
                  showTooltip('tooltip-cycle-camera-1');
                "
                style="float: right"
                icon
                color="red"
              >
                <img
                  class="control-button-image"
                  :src="videoView.switchCameraIconLink"
                />
              </v-btn>
            </template>
          </v-tooltip>

          <v-tooltip
            :text="
              videoView.closeChatLabel
                ? videoView.closeChatLabel
                : 'Disconnect Chat '
            "
            location="bottom"
          >
            <template v-slot:activator="{ props }">
              <v-btn
                id="disconnect-chat-btn"
                v-bind="props"
                rounded
                class="mx-2 control-button"
                @click="
                  $EventBus.emit('disconnectChatTriggred');
                  showTooltip('tooltip-disconnect-chat-2');
                "
                style="float: right"
                icon
                color="red"
              >
                <img
                  class="control-button-image"
                  :src="videoView.closeChatIconLink"
                />
              </v-btn>
            </template>
          </v-tooltip>
        </div>
      </div>
    </div>
    <div
      v-show="captionObject.onClosedCaption"
      class="caption-container"
      :style="{ bottom: drawer ? '150px !important' : isShowConstBtns ? '100px !important' : '0px !important' }"
    >
      <div class="cc-lines-wrapper font-normal">
        <div
          v-for="(item, index) in captionObject.captionMessages"
          :key="index"
          class="cc-line-wrapper"
        >
          <div ng class="cc-line">
            <div class="cc-name-wrapper">
              <div class="cc-name">{{ item.userName }}</div>
              <div>:</div>
            </div>
            <div class="cc-text">{{ item.text }}</div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="drawer" id="video-bottom-sheet">
      <div class="mobile-btns-group">
        <v-tooltip
          :text="
            videoView.switchToChatLabel ? videoView.switchToChatLabel : 'Chat'
          "
          location="bottom"
        >
          <template v-slot:activator="{ props }">
            <v-btn
              id="change-to-chat-btn"
              v-bind="props"
              rounded
              class="mx-2 control-button"
              @click="
                changeToChat();
                showTooltip('tooltip-change-to-chat-2');
              "
              style="float: right"
              icon
            >
              <v-badge color="pink" dot v-if="$store.state.newMessageCome">
                <img
                  v-if="videoView.chatIconLink"
                  class="control-button-image"
                  :src="videoView.chatIconLink"
                />
                <img
                  v-else-if="!videoView.chatIconLink"
                  class="control-button-image"
                  :src="require('@/assets/Chat_Icon.svg')"
                />
              </v-badge>
              <img
                v-else-if="
                  !$store.state.newMessageCome && videoView.chatIconLink
                "
                class="control-button-image"
                :src="videoView.chatIconLink"
              />
              <img
                v-else-if="
                  !$store.state.newMessageCome && !videoView.chatIconLink
                "
                class="control-button-image"
                :src="require('@/assets/Chat_Icon.svg')"
              />
            </v-btn>
          </template>
        </v-tooltip>

        <!----- start mic mute\unmute button ----->
        <v-tooltip
          :text="!isMicMuted ? videoView.micLabel : videoView.micOffLabel"
          location="bottom"
        >
          <template v-slot:activator="{ props }">
            <v-btn
              v-bind="props"
              id="mute-unmute-mic-btn"
              rounded
              :class="{
                'mic-muted': isMicMuted,
                'mic-unmuted': !isMicMuted,
                'control-button': true,
                'mx-2': true,
              }"
              @click="
                showTooltip('tooltip-mute-mic-btn-2');
                switchMuteMic();
              "
              style="float: right"
              icon
              color="red"
            >
              <img
                class="control-button-image"
                :src="
                  !isMicMuted ? videoView.micIconLink : videoView.micOffIconLink
                "
              />
            </v-btn>
          </template>
        </v-tooltip>

        <!----- end mic mute\unmute button ----->

        <!----- start cam mute\unmute button ----->
        <v-tooltip
          :text="!isCamMuted ? videoView.cameraLabel : videoView.cameraOffLabel"
          location="bottom"
        >
          <template v-slot:activator="{ props }">
            <v-btn
              v-bind="props"
              id="mute-unmute-cam-btn"
              rounded
              :class="{
                'cam-muted': isCamMuted,
                'cam-unmuted': !isCamMuted,
                'control-button': true,
                'mx-2': true,
              }"
              @click="
                switchMuteCamera();
                showTooltip('tooltip-mute-unmute-cam-1');
              "
              style="float: right"
              icon
              color="red"
            >
              <img
                class="control-button-image"
                :src="
                  !isCamMuted
                    ? videoView.cameraIconLink
                    : videoView.cameraOffIconLink
                "
              />
            </v-btn>
          </template>
        </v-tooltip>

        <!----- end cam mute\unmute button ----->

        <v-tooltip
          :text="
            videoView.switchCameraLabel
              ? videoView.switchCameraLabel
              : 'Switch Camera'
          "
          location="bottom"
        >
          <template v-slot:activator="{ props }">
            <v-btn
              id="cycle-camera-btn"
              v-bind="props"
              rounded
              class="mx-2 control-button"
              @click="
                cycleCamera();
                showTooltip('tooltip-cycle-camera-2');
              "
              style="float: right"
              icon
              color="red"
            >
              <img
                class="control-button-image"
                :src="videoView.switchCameraIconLink"
              />
            </v-btn>
          </template>
        </v-tooltip>

        <v-tooltip
          location="bottom"
          :text="
            videoView.closeChatLabel
              ? videoView.closeChatLabel
              : 'Disconnect Chat '
          "
        >
          <template v-slot:activator="{ props }">
            <v-btn
              id="disconnect-chat-btn"
              v-bind="props"
              rounded
              class="mx-2 control-button"
              @click="
                $EventBus.emit('disconnectChatTriggred');
                showTooltip('tooltip-disconnect-chat-1');
              "
              style="float: right"
              icon
              color="red"
            >
              <img
                class="control-button-image"
                :src="videoView.closeChatIconLink"
              />
            </v-btn>
          </template>
        </v-tooltip>
      </div>

      <div class="mobile-btns-group">
        <v-tooltip
          :text="
            !captionObject.onClosedCaption
              ? videoView.closedCaptionLabel
              : videoView.closedCaptionOffLabel
          "
          location="bottom"
        >
          <template v-slot:activator="{ props }">
            <v-btn
              v-bind="props"
              id="closed-caption-btn"
              v-if="captionObject.isShowClosedCaptionBtn"
              rounded
              class="mx-2 control-button"
              @click="handleClosedCaption()"
              style="float: 'right'"
              :class="{ 'share-on': captionObject.onClosedCaption }"
              icon
              color="#33333333"
            >
              <img
                class="control-button-image"
                :src="videoView.closedCaptionIconLink"
              />
            </v-btn>
          </template>
        </v-tooltip>

        <v-tooltip
          :text="
            !onShare
              ? videoView.shareScreenLabel
              : videoView.shareScreenOffLabel
          "
          location="bottom"
        >
          <template v-slot:activator="{ props }">
            <v-btn
              v-bind="props"
              id="share-screen-btn"
              v-if="videoView.isShowShareScreenBtn"
              rounded
              class="mx-2 control-button"
              @click="handleShare()"
              style="float: right"
              :class="{ 'share-on': onShare }"
              icon
              color="#33333333"
            >
              <img
                class="control-button-image"
                :src="videoView.shareScreenIconLink"
              />
            </v-btn>
          </template>
        </v-tooltip>

        <!----- start speakers button ----->

        <v-menu offset-y>
          <template v-slot:activator="{ props: menu }">
            <v-tooltip
              activator="child"
              location="bottom"
              :text="
                videoView.speakersDDLLabel
                  ? videoView.speakersDDLLabel
                  : 'Speakers list'
              "
            >
              <template v-slot:activator="{ props: tooltip }">
                <v-btn
                  id="speakers-list-btn"
                  class="mx-2 control-button"
                  style="float: right"
                  icon
                  color="red"
                  v-bind="getObjForOnListTooltip(menu, tooltip)"
                  rounded
                >
                  <img
                    class="control-button-image"
                    :src="videoView.switchSpeakerIconLink"
                  />
                </v-btn>
              </template>
            </v-tooltip>
          </template>
          <v-list>
            <v-list-item
              v-for="(item, index) in speakersListDDL"
              :key="index"
              @click="onSelectSpeaker"
              :class="{ 'ccvidyo-component-selected': item.selected }"
            >
              <v-list-item-title>{{ item.name }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>

        <v-menu offset-y>
          <template v-slot:activator="{ props: menu }">
            <v-tooltip
              activator="self"
              location="bottom"
              :text="
                videoView.micsDDLLabel
                  ? videoView.micsDDLLabel
                  : 'Microphones list'
              "
            >
              <template v-slot:activator="{ props: tooltip }">
                <v-btn
                  v-if="videoView.isShowMicsBtn"
                  id="mics-list-btn"
                  @click="showTooltip('tooltip-mics-list')"
                  class="mx-2 control-button"
                  style="float: right"
                  icon
                  color="red"
                  v-bind="getObjForOnListTooltip(menu, tooltip)"
                >
                  <img
                    class="control-button-image"
                    :src="videoView.switchMicIconLink"
                  />
                </v-btn>
              </template>
            </v-tooltip>
          </template>
          <v-list>
            <v-list-item
              v-for="(item, index) in micsListDDL"
              :key="index"
              @click="onSelectMic"
              :class="{ 'ccvidyo-component-selected': item.selected }"
            >
              <v-list-item-title>{{ item.name }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>

        <v-tooltip
          v-if="videoView.isShowCloseVideo"
          :text="
            videoView.closeVideoLabel
              ? videoView.closeVideoLabel
              : 'Disconnect Video'
          "
          location="bottom"
        >
          <template v-slot:activator="{ props }">
            <v-btn
              v-bind="props"
              id="close-video-btn"
              rounded
              class="mx-2 control-button"
              @click="
                disconnectVideoClicked();
                showTooltip('tooltip-close-video');
              "
              style="float: right"
              icon
              color="red"
            >
              <img
                class="control-button-image"
                :src="videoView.closeVideoIconLink"
              />
            </v-btn>
          </template>
        </v-tooltip>
      </div>
    </div>

    <v-tooltip :text="netWarnText" bottom v-if="!callOnHold && showNetWarn">
      <template v-slot:activator="{ props }">
        <img
          v-bind="props"
          class="network-warning-image"
          :src="widgetData.videoNetWarningProps.warningIconLink"
        />
      </template>
    </v-tooltip>
    <div v-show="!callOnHold" id="renderer" style="height: calc(100%)"></div>
  </div>
</template>

<script>
import ConsoleLogService from "../services/ConsoleLogService";
import Utils from "../helpers/utils";
import { mapGetters } from "vuex";
import VidyoService from "../services/VidyoService";
import ErrorService from "../services/ErrorService";
import axios from "axios";
import $ from "jquery";
import { watch } from "vue";

export default {
  name: "Vidyo",
  data() {
    return {
      onShare: false,
      isCamMuted: false,
      isMicMuted: false,
      camerasObject: {},
      speakersObject: {},
      micsObject: {},
      camerasListDDL: [],
      speakersListDDL: [],
      micsListDDL: [],
      initIsDirty: false,
      isLastStateCamMuted: false,
      isLastStateMicMuted: false,
      showVideoButtons: false,
      drawer: false,
      group: null,
      isShowConstBtns: true,
      showConstBtnsTimout: null,
      showNetWarn: false,
      netWarnText: "",
      captionObject: {
        tokens: {},
        onClosedCaption: false,
        captionMessages: [],
        isShowClosedCaptionBtn: false,
      },
    };
  },
  computed: {
    ...mapGetters([
      "widgetData",
      "isConnect",
      "videoView",
      "currentView",
      "agentAutoMessage",
      "videoConfig",
      "callOnHold",
    ]),
    isMobile() {
      return Utils.mobileCheck();
    },
    isShowTooltipOnHover() {
      return (
        (this.isMobile && !this.widgetData.config.disableTooltipOnMobile) ||
        !this.isMobile
      );
    },
  },
  mounted() {
    // Just in case not already loaded
    ConsoleLogService.readConfig();
    this.showConstBtns();
    this.initVidyo();
    watch(this.agentAutoMessage, (newVal, oldVal) => {
      Utils.log.debug("agentAutoMessage watcher, message is: " + newVal);
      if (newVal === "vidyo_end_video_call") {
        VidyoService.disconnectVidyoCall();
      }
    });
    watch(this.callOnHold, (newVal, oldVal) => {
      if (typeof vidyoConnector === undefined) return;
      Utils.log.debug("watcher - callOnHold, newVal is: ", newVal);
      // let vid = document.getElementById("holdVideo");

      if (newVal === true) {
        this.isLastStateCamMuted = this.isCamMuted;
        this.isLastStateMicMuted = this.isMicMuted;
        this.isCamMuted = false;
        this.isMicMuted = false;
      } else {
        this.isCamMuted = !this.isLastStateCamMuted;
        this.isMicMuted = !this.isLastStateMicMuted;
      }
      // this.showHoldVideo = newVal;
      this.setSpeakerPrivacy(newVal);
      this.switchMuteCamera();
      this.switchMuteMic();
    });

    watch(this.group, () => {
      this.drawer = false;
    });

  },
  methods: {
    showConstBtns() {
      if (!this.videoView.isShowHideConstBtsGroup) {
        return;
      }
      this.isShowConstBtns = true;
      clearTimeout(this.showConstBtnsTimout);
      this.showConstBtnsTimout = setTimeout(() => {
        this.isShowConstBtns = false;
      }, 5000);
    },
    getObjForOnListTooltip(on, onTooltip) {
      return this.isShowTooltipOnHover ? { ...on, ...onTooltip } : { ...on };
    },
    showTooltip(id) {
      if (
        (!Utils.mobileCheck() && !Utils.isSafari()) ||
        (Utils.mobileCheck() && this.widgetData.config.disableTooltipOnMobile)
      ) {
        return;
      }
      //need seTimeout, because sometimes "el" is null - since the tooltip still doesn't appear
      setTimeout(() => {
        let el = document.querySelector("#" + id);
        if (el) {
          Utils.log.debug("showTooltip: " + id);
          document.querySelector("#" + id).parentElement.style.display =
            "block";
          document.querySelector("#" + id).parentElement.style.opacity = "0.9";
          setTimeout(() => {
            document.querySelector("#" + id).parentElement.style.display =
              "none";
          }, 1000);
        }
      }, 700);
    },
    initVidyo() {
      if (!this.$store.state.videoMessage.text) {
        return;
      }
      this.paramsArr = Utils.getCustomUrlVars(
        this.$store.state.videoMessage.text.split(
          window.Vidyo_Identifier_SendInviteMessage
        )[1]
      );
      if (this.paramsArr.token) {
        this.paramsArr.token = decodeURIComponent(this.paramsArr.token);
      }
      if (this.paramsArr.displayname) {
        this.paramsArr.token = decodeURIComponent(this.paramsArr.displayname);
      }

      VidyoService.initFromVidyoComponent(this.paramsArr, {
        // onDisconnect: this.onDisconnect.bind(this),
        onStopShare: this.onStopShare.bind(this),
        muteDevices: this.muteDevices.bind(this),
        onAddCamera: this.onAddCamera.bind(this),
        onAddSpeaker: this.onAddSpeaker.bind(this),
        onAddMic: this.onAddMic.bind(this),
        onSelectCamera: this.onSelectCamera.bind(this),
        onSelectSpeaker: this.onSelectSpeaker.bind(this),
        onSelectMic: this.onSelectMic.bind(this),
        onJoinSuccess: this.onJoinSuccess.bind(this),
        onConnectorReady: this.onConnectorReady.bind(this),
        onNetWarning: this.onNetWarning.bind(this),
      });
      // this.initIsDirty = true;
      if (this.videoView.isShowClosedCaptionBtn) {
        this.captionObject.isShowClosedCaptionBtn =
        this.videoView.isShowClosedCaptionBtn;
        document.addEventListener(
          "visibilitychange",
          this.scrollOnVissibilityChange
        );
      }
    },
    handleClosedCaption() {
      try {
        this.initCaptionObject();
        if (this.captionObject.onClosedCaption) this.unsubscribeFromTopic();
        else this.subscribeToTopic();
      } catch {
        var op = this.captionObject.onClosedCaption ? "stopping" : "starting";
        ErrorService.displayAlert(
          "error " + op + " closed captioning subscription",
          "error"
        );
      }
    },
    onNetWarning(warn, text) {
      if (this.widgetData.videoNetWarningProps.showingType == "icon") {
        this.showNetWarn = warn;
        this.netWarnText = text ? text : "";
      } else if (
        warn &&
        this.widgetData.videoNetWarningProps.showingType == "alert"
      ) {
        ErrorService.displayAlert(text, "info");
      }

      // TODO: let know agent that we have bad network???
    },
    highlightItem(list, name) {
      list.forEach((element) => {
        element.selected = undefined;
      });
      let found = list.findIndex((it) => it.name === name);
      if (found > -1) {
        list[found].selected = true;
      }
    },
    cycleCamera() {
      VidyoService.cycleCamera();
    },
    onSelectCamera(e) {
      Utils.log.debug("onSelectCamera");
      let camName;
      //if from click
      if (e.target) {
        camName = e.target.innerText;
        VidyoService.selectLocalCamera(this.camerasObject[camName]);
      } else {
        camName = e;
      }
      this.highlightItem(this.camerasListDDL, camName);
    },
    onSelectMic(e) {
      Utils.log.debug("onSelectMic");
      let micName;
      if (e.target) {
        micName = e.target.innerText;
        VidyoService.selectLocalMic(this.micsObject[micName]);
      } else {
        micName = e;
      }
      this.highlightItem(this.micsListDDL, micName);
    },
    onSelectSpeaker(e) {
      Utils.log.debug("onSelectSpeaker");
      let speakerName;
      if (e.target) {
        speakerName = e.target.innerText;
        VidyoService.selectLocalSpeaker(this.speakersObject[speakerName]);
      } else {
        speakerName = e;
      }
      this.highlightItem(this.speakersListDDL, speakerName);
    },

    onAddCamera(camera) {
      this.camerasObject[camera.name] = camera;
      this.camerasListDDL.push({ name: camera.name, selected: false });
    },
    onAddSpeaker(speaker) {
      this.speakersObject[speaker.name] = speaker;
      this.speakersListDDL.push({ name: speaker.name, selected: false });
    },
    onAddMic(mic) {
      this.micsObject[mic.name] = mic;
      this.micsListDDL.push({ name: mic.name, selected: false });
    },
    muteDevices() {
      Utils.log.debug("on muteDevices at vidyo.vue ");
      //Also if undefined. Because we want the default state will be muted
      if (this.widgetData.config.camMicMutedByDefault !== false) {
        this.isCamMuted = false;
        this.isMicMuted = false;
        this.switchMuteCamera();
        this.switchMuteMic();
      } else if (
        this.widgetData.videoConfig &&
        this.widgetData.videoConfig.camMutedByDefault !== false
      ) {
        this.isCamMuted = false;
        this.switchMuteCamera();
      }
    },
    switchMuteCamera() {
      Utils.log.debug("switchMuteCamera");
      VidyoService.setCameraPrivacy(!this.isCamMuted)
        .then(() => {
          this.isCamMuted = !this.isCamMuted;
        })
        .catch(() => {});
    },

    switchMuteMic() {
      Utils.log.debug("switchMuteMic");
      VidyoService.setMicPrivacy(!this.isMicMuted).then(() => {
        this.isMicMuted = !this.isMicMuted;
      });
    },
    setSpeakerPrivacy(flag) {
      Utils.log.debug("setSpeakerPrivacy" + flag);
      VidyoService.setSpeakerPrivacy(flag).then(() => {});
    },

    handleShare() {
      if (this.onShare) {
        VidyoService.stopShare().then(() => {
          this.onShare = false;
        });
      } else {
        VidyoService.startShare().then(() => {
          this.onShare = true;
        });
      }
    },
    changeToChat() {
      this.drawer = false;
      this.$store.commit("setCurrentView", "chat");
      this.$store.commit("setNewMessageCome", false);
    },
    disconnectVideoClicked() {
      VidyoService.disconnectVidyoCall();
      this.$store.commit("setVideoLoader", false);
    },
    onStopShare() {
      this.onShare = false;
    },
    onDisconnect() {},
    // saveLogClicked() {
    //   ConsoleLogService.createLogs();
    // },
    onJoinSuccess() {},
    onConnectorReady() {
      this.showVideoButtons = true;
    },
    async unsubscribeFromTopic() {
      try {
        if (!this.captionObject.tokens.subscriptionToken) return;
        var req = {
          method: "GET",
          url: `${this.videoView.closedCaptionServiceUrl}/stopClosedCaptioning`,
          headers: {
            Authorization: `Bearer ${this.captionObject.tokens.jwtToken.jwtToken}`,
          },
        };
        const response = await axios(req);
        var unsubscribed = await VidyoService.unsubscribeFromTopic(
          this.captionObject.tokens.subscriptionToken
        );
        if (unsubscribed) {
          this.captionObject.captionMessages = [];
          this.captionObject.timeout = null;
          this.captionObject.tokens = {};
          this.captionObject.onClosedCaption =
            !this.captionObject.onClosedCaption;
        } else
          ErrorService.displayAlert(
            "error stopping closed captioning subscription",
            "error"
          );
      } catch (error) {
        ErrorService.displayAlert(
          "error stopping closed captioning subscription",
          "error"
        );
      }
    },
    async subscribeToTopic() {
      try {
        this.captionObject.tokens.jwtToken = await VidyoService.getJWTToken();
        var req = {
          method: "GET",
          url: `${this.videoView.closedCaptionServiceUrl}/startClosedCaptioning`,
          headers: {
            Authorization: `Bearer ${this.captionObject.tokens.jwtToken.jwtToken}`,
          },
        };
        const response = await axios(req);
        const subscriptionToken = response.data.data.subscriptionToken;
        this.captionObject.tokens.subscriptionToken = subscriptionToken;
        var subscribed = await VidyoService.subscribeToTopic(
          subscriptionToken,
          this.subscribeOnMesaages,
          this.subscribedToTopicStatusCallback
        );

        if (subscribed) {
          this.captionObject.timeout = setTimeout(this.scroll, this.getTime());
          this.captionObject.onClosedCaption =
            !this.captionObject.onClosedCaption;
        } else
          ErrorService.displayAlert(
            "error starting closed captioning subscription",
            "error"
          );
        // Perform any additional actions here
      } catch (error) {
        ErrorService.displayAlert(
          "error starting closed captioning subscription",
          "error"
        );
      }
    },
    subscribedToTopicStatusCallback(status) {
      Utils.log.debug("SubscribedToTopicStatusCallback", status);
    },
    initCaptionObject() {
      this.captionObject.MSG_BEGAN = "B";
      this.captionObject.MSG_UPDATED = "U";
      this.captionObject.MSG_FINISHED = "F";
      this.captionObject.DEFAULT_BLACK_COLOR = "#000000";
      this.captionObject.DEFAULT_WHITE_COLOR = "#ffffff";
      this.captionObject.DEFAULT_FONT_SIZE = "18px";
      this.captionObject.LINE_HEIGHT_COEFICIENT = 1.5;
      this.captionObject.LINES_IN_HISTORY = 8;
      this.captionObject._fontSize = parseInt(
        this.captionObject.DEFAULT_FONT_SIZE
      );
      this.captionObject.container = $(".cc-lines-wrapper");
      this.captionObject._messagesQueue = [];
      this.captionObject.isDocumentVisible = true;
      this.captionObject.timeout = null;

      this.captionObject.container.css(
        "fontSize",
        this.captionObject._fontSize
      );
    },
    parseCaptionMessage(message) {
      const isMessageTextEmpty = message.trim().endsWith("]");
      const messagePropertyarray = message.split("]");
      const userNameArr = messagePropertyarray
        .slice(2, -1)
        .join("]")
        ?.trim()
        .replace("[", "")
        .split(" ");
      const firstName = userNameArr[0];
      const lastName = userNameArr[1] || "";
      const text = isMessageTextEmpty
        ? ""
        : messagePropertyarray[messagePropertyarray.length - 1].trim();
      return {
        index: messagePropertyarray[0].trim().replace("[", ""),
        flag: messagePropertyarray[1].trim().replace("[", ""),
        userName: `${firstName} ${lastName}`.trim(),
        text,
        timestamp: Date.now(),
      };
    },
    isElementScrolledToBottom(element) {
      if (element) {
        return (
          Math.abs(
            element.scrollHeight - element.clientHeight - element.scrollTop
          ) < 5
        );
      }
    },
    setMessages(msgArrProp) {
      let msgArr = msgArrProp;
      if (!this.captionObject.isDocumentVisible) {
        msgArr = msgArr.slice(-this.captionObject.LINES_IN_HISTORY - 2);
      }
      this.captionObject.captionMessages = [...msgArr];
    },
    getTime() {
      const fontCof =
        this.captionObject._fontSize === 18
          ? 1
          : this.captionObject._fontSize > 18
          ? 0.7
          : 1.3;
      return Math.min(
        Math.max(this.captionObject.container.width() * 2 * fontCof, 1000),
        2500
      );
    },
    scroll() {
      if (
        this.captionObject.container &&
        !this.isElementScrolledToBottom(this.captionObject.container[0])
      ) {
        this.captionObject.container.scrollTop(
          this.captionObject.container[0].scrollHeight
        );
      }
      this.captionObject.timeout = setTimeout(this.scroll, this.getTime());
    },
    scrollOnVissibilityChange() {
      if (
        this.captionObject.container &&
        document.visibilityState === "visible"
      ) {
        this.captionObject.isDocumentVisible = true;
        this.captionObject.captionMessages =
          this.captionObject.captionMessages.slice(
            -this.captionObject.LINES_IN_HISTORY
          );

        this.captionObject.container[0].scrollTo({
          top: this.captionObject.container[0].scrollHeight,
          behavior: "instant",
        });
      } else {
        this.captionObject.isDocumentVisible = false;
      }
    },
    handeMsg(parsedMsg) {
      const lastMessage =
        this.captionObject.captionMessages[
          this.captionObject.captionMessages.length - 1
        ];

      if (!this.captionObject.captionMessages.length) {
        this.setMessages([parsedMsg]);
      } else if (lastMessage?.index === parsedMsg.index) {
        if (parsedMsg.flag === this.captionObject.MSG_FINISHED) {
          if (this.isElementScrolledToBottom(this.captionObject.container[0])) {
            if (lastMessage?.flag === this.captionObject.MSG_FINISHED) {
              const lastFewMsgs = this.captionObject.captionMessages.slice(
                -this.captionObject.LINES_IN_HISTORY
              );
              this.setMessages([
                ...lastFewMsgs,
                parsedMsg,
                ...this.captionObject._messagesQueue,
              ]);
            } else {
              const lastFewMsgs = this.captionObject.captionMessages.slice(
                -this.captionObject.LINES_IN_HISTORY - 1
              );
              lastFewMsgs.pop();
              this.setMessages([
                ...lastFewMsgs,
                parsedMsg,
                ...this.captionObject._messagesQueue,
              ]);
            }
            this.captionObject._messagesQueue = [];
          } else {
            if (lastMessage?.flag !== this.captionObject.MSG_FINISHED) {
              this.captionObject.captionMessages.pop();
            }
            this.setMessages([
              ...this.captionObject.captionMessages,
              parsedMsg,
              ...this.captionObject._messagesQueue,
            ]);
            this.captionObject._messagesQueue = [];
          }
        } else {
          if (lastMessage?.flag !== this.captionObject.MSG_FINISHED) {
            this.captionObject.captionMessages.pop();
          }
          this.setMessages([...this.captionObject.captionMessages, parsedMsg]);

          const distanceToBottom = Math.abs(
            this.captionObject.container[0].scrollHeight -
              this.captionObject.container[0].clientHeight -
              this.captionObject.container[0].scrollTop
          );
          if (
            distanceToBottom > 0 &&
            distanceToBottom < this.getLineHeight() * 1.2
          ) {
            this.captionObject.container[0].scrollTo({
              top: this.captionObject.container[0].scrollHeight,
              behavior: "smooth",
            });
          }
        }
      } else {
        if (
          lastMessage.flag === this.captionObject.MSG_FINISHED ||
          (Date.now() - lastMessage.timestamp > 5000 &&
            this.isElementScrolledToBottom(this.captionObject.container[0]))
        ) {
          this.setMessages([...this.captionObject.captionMessages, parsedMsg]);
        } else if (parsedMsg.flag === this.captionObject.MSG_FINISHED) {
          this.captionObject._messagesQueue.push(parsedMsg);
        }
      }
    },
    getLineHeight() {
      // Calculate the height of the container
      if (this.captionObject.container) this.captionObject.container.height();
      else return 0;
    },
    handeMsgWithThrottling(parsedMsg) {
      this.handeMsg(parsedMsg);
    },
    subscribeOnMesaages(msg) {
      if (!this.captionObject.container) return;
      let parsedMsg = this.parseCaptionMessage(msg);
      const lastMsg =
        this.captionObject.captionMessages[
          this.captionObject.captionMessages.length - 1
        ];

      if (!parsedMsg.text) {
        if (
          parsedMsg?.flag === this.captionObject.MSG_FINISHED &&
          lastMsg?.index === parsedMsg.index &&
          lastMsg?.flag !== this.captionObject.MSG_FINISHED
        ) {
          lastMsg.flag = this.captionObject.MSG_FINISHED;
          return;
        } else {
          return;
        }
      }

      if (
        lastMsg?.index === parsedMsg.index &&
        lastMsg?.flag === parsedMsg.flag &&
        parsedMsg.flag === this.captionObject.MSG_UPDATED
      ) {
        this.handeMsgWithThrottling(parsedMsg);
      } else {
        this.handeMsg(parsedMsg);
      }
    },
  },
  beforeDestroy: function () {
    this.$store.commit("setNewMessageCome", false);
  },
};
</script>

<style scoped>
.btn-wrap {
  z-index: 100000;
  position: absolute;
  right: 0;
  opacity: 0.5;
}
.btn-wrap:hover {
  opacity: 1;
}

.control-button-image {
  max-width: 22px;
}
.mx-2 {
  margin-top: 25px;
}
.mobile-btns-group {
  display: flex;
  justify-content: center;
}

#constBtnsWrapper {
  width: 100%;
  height: 100px;
  bottom: 0;
  position: absolute;
}

.network-warning-image {
  width: 60px;
  height: 60px;
  position: absolute;
  z-index: 10000000000;
  margin-top: 22px;
  margin-left: 100px;
}
.ccvidyo-component .control-button {
  z-index: 10000;
}
#video-bottom-sheet {
  width: 100%;
}

/* closed caption*/

.caption-container {
  position: absolute !important;
  z-index: 100000;
  background-color: aliceblue;
  width: 100%;
  margin: auto;
  display: flex;
  justify-content: center;
}
.caption-container .cc-lines-wrapper {
  display: flex;
  flex-direction: column;
  height: 3em;
  overflow-y: hidden;
  position: relative;
}
.caption-container .cc-lines-wrapper.safari {
  overflow-y: auto;
}
.caption-container .cc-lines-wrapper:not(.font-big) {
  height: 4.5em;
}
.caption-container .cc-lines-wrapper .cc-line-wrapper .cc-line {
  display: flex;
  justify-content: flex-end;
  width: 100%;
  line-height: 1.5em;
}
.caption-container
  .cc-lines-wrapper
  .cc-line-wrapper
  .cc-line
  .cc-name-wrapper {
  text-align: right;
  height: 1.5em;
  position: sticky;
  top: 0;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-right: 1em;
  font-weight: 500;
}
.caption-container
  .cc-lines-wrapper
  .cc-line-wrapper
  .cc-line
  .cc-name-wrapper
  .cc-name {
  width: calc(1em * 8);
  line-height: 1.5em;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.caption-container .cc-lines-wrapper .cc-line-wrapper .cc-line .cc-text {
  width: 100%;
}
@supports (scroll-behavior: smooth) {
  .cc-lines-wrapper {
    scroll-behavior: smooth;
  }
}
body.in-mini-view-mode .caption-container {
  height: 205px;
}
body.in-mini-view-mode .cc-lines-wrapper.font-normal {
  height: 9em;
}
body.in-mini-view-mode .cc-lines-wrapper.font-small {
  height: 12em;
}
body.in-mini-view-mode .cc-lines-wrapper.font-big {
  height: 7.5em;
}
@media screen and (max-width: 500px) {
  .caption-container {
    padding: 0px 10px 0px 5px;
  }
  .caption-container
    .cc-lines-wrapper
    .cc-line-wrapper
    .cc-line
    .cc-name-wrapper {
    padding-right: 0.5em;
  }
  .caption-container
    .cc-lines-wrapper
    .cc-line-wrapper
    .cc-line
    .cc-name-wrapper
    .cc-name {
    width: calc(1em * 6);
  }
}
</style>
